import React, { useEffect, useState } from 'react';
import {Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { 
  COVERLETTER_CUSTOMIZE,
  COVERLETTER_EXPERIENCE,
  COVERLETTER_JOBDETAILS,
  COVERLETTER_SKILLS,
  COVERLETTER_STRENGTH
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import SkillsForm from './QuesAnsSections/SkillsForm';

const Skills = (props) => {
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);

    const { 
      ques_ans_response,
      qa_steps_initiated,
    handlers: {
        saveQA,
        loadQA
    },
  } = useCoverLetter();

  const saveForm = (data) => {

    saveQA({ ques_ans_response: {...ques_ans_response, ...data} })
  }
  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    loadQA()
  }, []);

  useEffect(() => {
    (next || back) && history.pushState(null, COVERLETTER_SKILLS);
    next && setRedirect2(COVERLETTER_STRENGTH)
    // next && save()
    back && setRedirect2(
      ques_ans_response.job_details_provided == true ?
      COVERLETTER_JOBDETAILS :
      COVERLETTER_CUSTOMIZE
      )
  }, [back, next]);

  if (redirect2) return <Redirect to={redirect2} />

  return (
    <div className="cover-screen-outer cover-skills-screen">
    <div className="screen-inner">
      <div className="block">
          <div className="progress-bar">
              <div className="bar-outer">
                  <div className="bar-inner"></div>
              </div>
              <div className="bar-levels">
                  <div className="level-text"><span className="level-mark"></span>Select a Template</div>
                  <div className="level-text active"><span className="level-mark"></span>Job Goals</div>
                  <div className="level-text"><span className="level-mark"></span>Work Info</div>
                  <div className="level-text"><span className="level-mark"></span>Finalize</div>
              </div>
            </div>
        <div className="screen screen-four">
          <h1>What are your best skills?</h1>
          <p>We'll highlight skills in your cover letter to show you're a good fit for the job.</p>
            <SkillsForm data={{...ques_ans_response, qa_steps_initiated}} save={(p)=>saveForm(p)}/>
            {/* //Duplicate screen end  */}
          <div className="screen-action">
          <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button>
          <button className="round-btn  active" onClick={() => setNext(!next)}><span>Next</span><i className="arrow-bar-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default Skills;